import $ from 'jquery';
// import AOS from 'aos';
import { langSwitch } from './components/langSwitch';
import { navigation } from './components/navigation';
import { accordion } from './components/accordion';
import { calculator } from './components/calculator';
import 'font-awesome/css/font-awesome.css';

$(document).ready(() => {
    // AOS.init(); //Init fade effects

    langSwitch();
    navigation();
    accordion();
    if (document.getElementById('calculator')) {
        calculator();
    }
});

$('.calculator .read-more-calc').click(function () {
   $(this).next().slideToggle();
});

